export const SET_PLAYLIST_TRACKS = 'SET_PLAYLIST_TRACKS';
const _setPlaylistTracks = (trackList) => ({
    type: SET_PLAYLIST_TRACKS,
    trackList,
});

export const SET_PLAYLIST_TYPE = 'SET_PLAYLIST_TYPE';
const _setPlaylistType = (playlistType) => ({
    type: SET_PLAYLIST_TYPE,
    playlistType,
});

export const SET_CURRENT_TRACK = 'SET_CURRENT_TRACK';
export const _setCurrentTrack = (currentIndex, currentMusicId) => ({
    type: SET_CURRENT_TRACK,
    currentIndex,
    currentMusicId,
});

export const setPlaylistTracks = (trackList) => (dispatch) => dispatch(_setPlaylistTracks(trackList));

export const setPlaylistType = (playlistType) => (dispatch) => dispatch(_setPlaylistType(playlistType));

export const setCurrentTrack = (currentIndex, currentMusicId) => (dispatch) => dispatch(_setCurrentTrack(currentIndex, currentMusicId));

export const setPlaylist = (playlistType, trackList, currentIndex, currentMusicId) => (dispatch) => {
    const myPromises = [
        dispatch(setPlaylistType(playlistType)),
        dispatch(setPlaylistTracks(trackList)),
        dispatch(setCurrentTrack(currentIndex, currentMusicId)),
    ];

    return Promise.all(myPromises);
};
